export default (o, c, d) => {
  const proto = c.prototype;
  proto.getTimestamp = function () {
    let inst = this;
    return inst.valueOf();
  };
};
